import axios from 'axios'
import { store } from '../NextApp'
import { handleSessionExpired, isSessionInvalidResponse } from 'util/sessionExpiredHandler'

const handle403Response = (response: any) => {
  const { status, data } = response;
  if (isSessionInvalidResponse(status, data)) {
    handleSessionExpired(store, data?.message);
  }
  return response;
};

export const APIGetRequest = async (URL:string, setHeaders:any) =>{

    return await axios.get(URL, setHeaders)
    .then(response => {
      const result = response.data;
      // Check for 403 in response body even if HTTP status is 200
      handle403Response({ status: response.status || 200, data: result });
      return result;
    })
    .catch(error =>{
        if(error.response) {
        // Request made and server responded

            const {status,data} = error.response
            // Handle 403
            handle403Response({ status, data });
            return {status,data:{message:data.message,data:data.data}}
        } else if (error.request) {
        // The request was made but no response was received
            return {status:500,data:{message:error,data:undefined}}
        } else {
            // Something happened in setting up the request that triggered an Error
        }})
}

export const APIPostRequest = async (URL:string,API_DATABODY:any, setHeaders:any) =>{
    return await axios.post(URL,API_DATABODY, setHeaders)
    .then(response => {
      const result = response.data;
      // Check for 403 in response body even if HTTP status is 200
      handle403Response({ status: response.status || 200, data: result });
      return result;
    })
    .catch(error => { 
      if (error.response) {
        // Request made and server responded
        const {status,data} = error.response
        // Handle 403
        handle403Response({ status, data });
        return {status,data:{message:data.message,data:data.data}}
      } else if (error.request) {
        // The request was made but no response was received
        // Check for CORS errors
        const errorMessage = error.message || String(error);
        const isCorsError = errorMessage.includes('CORS') || 
                           errorMessage.includes('Access-Control') ||
                           errorMessage.includes('ERR_FAILED');
        
        if (isCorsError) {
          console.error('CORS Error: Backend server needs to allow requests from:', window.location.origin);
          console.error('Request URL:', URL);
          return {
            status: 500,
            data: {
              message: 'CORS Error: Backend server configuration issue. Please contact administrator.',
              data: undefined
            }
          };
        }
        
        return {status:500,data:{message:error,data:undefined}}
      } else {
        // Something happened in setting up the request that triggered an Error
        return {status:500,data:{message:error.message || 'Unknown error',data:undefined}}
      }
    })
}
